let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kdo3S")).then(() => parcelRequire('bUxcb'));